import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

import { useCurrentActor } from 'components/contexts/CurrentActor';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function DuplicationWithOutOfDateActivitiesModal({
  onClose,
  onConfirmDupWithOutOfDateActivities,
  originalProject,
  outOfDateActivities,
}) {
  const {
    division: {
      attributes: { singularRAMSName },
    },
  } = useCurrentActor();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix:
      'projectsDashboard.components.DuplicationWithOutOfDateActivitiesModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={() => onClose({ projectId: originalProject.id })}
            size='md'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <FilledButton
            color='mint'
            onClick={onConfirmDupWithOutOfDateActivities}
          >
            {i18nT('button')}
          </FilledButton>
        </div>
      }
      isOpen={true}
      mode='flexible'
      onClose={() => onClose({ projectId: originalProject.id })}
    >
      <>
        <h2 className='modalbox-header__title truncated-text-container tw-border-0 tw-border-b-1 tw-border-solid tw-border-grey-100 tw-p-6 tw-text-l tw-font-semibold tw-text-grey-900'>
          {i18nT('title', {
            interpolation: { escapeValue: false },
            projectName: originalProject.attributes.name,
          })}
        </h2>
        <section className='tw-p-6'>
          <div className='tw-mb-4 tw-text-m tw-font-semibold tw-text-grey-700'>
            {i18nT('description', {
              interpolation: { escapeValue: false },
              singularRAMSName,
            })}
          </div>
          <div>
            {outOfDateActivities.map((activity) => (
              <div
                className='tw-mb-1 tw-rounded-lg tw-bg-grey-025 tw-p-2'
                key={activity.id}
              >
                {activity.attributes.name}
              </div>
            ))}
          </div>
        </section>
      </>
    </ModalBox>
  );
}

DuplicationWithOutOfDateActivitiesModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirmDupWithOutOfDateActivities: PropTypes.func.isRequired,
  originalProject: PropTypes.object.isRequired,
  outOfDateActivities: PropTypes.arrayOf(resourceShape('activity').isRequired),
};
